import {useAuthState} from 'react-firebase-hooks/auth';

import {firebase} from '@/library';

export default function useFirebaseAuthState() {
	return useAuthState(firebase.authInstance);
}
